import { AfterViewInit, Component, EventEmitter, Output, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { OpbCompanyService } from '../../../services/opb-company.service';
import { OpbCompanyDto, OpbCompaniesSearchRequest } from '../../../models/api/opbCompanyDto';

@Component({
  selector: 'app-add-connection-opb-company-search',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatSortModule,
    MatInputModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    NgxSpinnerModule,
    FormsModule
  ],
  templateUrl: './add-connection-opb-company-search.component.html',
  styleUrls: ['./add-connection-opb-company-search.component.scss']
})
export class AddConnectionOpbCompanySearchComponent implements AfterViewInit {
  @Output() opbCompanySelected = new EventEmitter<OpbCompanyDto | null>();

  private opbCompanyService = inject(OpbCompanyService);
  private spinnerService = inject(NgxSpinnerService);

  dataSource = new MatTableDataSource<OpbCompanyDto>([]);
  displayedColumns: string[] = ['actions', 'name', 'countryName', 'sectorName'];
  pageSize: number = 5;
  selectedOpbCompany: OpbCompanyDto | null = null;

  @ViewChild(MatSort, { static: false }) sort!: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;

  searchForm = {
    name: ''
  };

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  onSearch(): void {
    this.searchOpbCompanies();
  }

  searchOpbCompanies(): void {
    if (!this.searchForm.name || this.searchForm.name.trim() === '') {
      return;
    }

    const request: OpbCompaniesSearchRequest = {
      name: this.searchForm.name,
      isTransferred: false,
      pageNumber: 1,
      pageSize: 100,
      sortBy: 'Name',
      ascending: true
    };

    this.spinnerService.show();
    this.opbCompanyService.searchOpbCompanies(request).subscribe({
      next: (response) => {
        this.dataSource.data = response.data;
        if (this.paginator) {
          this.paginator.firstPage();
        }
        this.spinnerService.hide();
      },
      error: (error) => {
        console.error('Error searching OPB companies:', error);
        this.spinnerService.hide();
      }
    });
  }

  onConnect(opbCompany: OpbCompanyDto): void {
    if (this.selectedOpbCompany?.id === opbCompany.id) {
      this.selectedOpbCompany = null;
    } else {
      this.selectedOpbCompany = opbCompany;
    }
    this.opbCompanySelected.emit(this.selectedOpbCompany);
  }

  isSelected(opbCompany: OpbCompanyDto): boolean {
    return this.selectedOpbCompany?.id === opbCompany.id;
  }
}
